import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "antd";
import { AppDispatch, RootState } from "../../../../apis/store";
import {
  getDateRange,
  scroll,
} from "../../../../components/utils/utils";
import Selects from "../../../../biblio/Selects/Selects";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import DroppedOutRequestsList from "./DroppedOutRequestsList";
import DropoutRequest from "./DropoutRequest";
import { getDroppedOutRequests } from "../../../../apis/actions/scholarship.actions";
import { getBeneficiaryDetails } from "../../../../apis/actions/recipient.actions";
import CustomConfigProvider from "../../ProfileHeader";
const DroppedOutRequestsOverview = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);
  const { droppedOutRequests, loading, TotalDropouts } = useSelector(
    (state: RootState) => state?.scholarship
  );
  const { beneficiaryDetails } = useSelector(
    (state: RootState) => state?.recipient
  );

  const [selectedBeneficiary, setSelectedBeneficiary] = useState<any>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [filterChanged, setFilterChanged] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [state, setState] = useState({
    year: "",
    month: "",
  });
  const filterOrphans =
    beneficiaryDetails?.person_ids &&
    beneficiaryDetails.person_ids.filter(
      (person: any) =>
        person?.beneficiary_type === "son" ||
        person?.beneficiary_type === "daughter"
    );
  useEffect(() => {
  if (filterChanged || currentPage) {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      getDroppedOutRequests({
        limit: itemPerPage,
        page: currentPage,
        date_from,
        date_to,
        partner_id: selectedBeneficiary,
      })
    );

    setFilterChanged(false); 
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [dispatch, currentPage, filterChanged]); 

  useEffect(() => {
    dispatch(getBeneficiaryDetails());
  }, [dispatch]);
useEffect(() => {
  setCurrentPage(1);
  setFilterChanged(true);
}, [selectedBeneficiary, state]);

  const updateActive = useCallback((nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  }, []);

  // Reset page to 1 when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [state, selectedBeneficiary]);

  const itemPerPage = 8;
  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedBeneficiary(
        // eslint-disable-next-line eqeqeq
        filterOrphans.filter((person: any) => person.name == value?.label)[0]
          ?.id
      );
      setCurrentPage(1);
    } else {
      setSelectedBeneficiary(null);
    }
  };

  return (
    <>
      <CustomConfigProvider
        title="المنقطعين عن الدراسة"
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
      >
        <Selects
          options={filterOrphans}
          selectPlaceholder="المستفيد"
          onChange={handleSelectChange}
          allowClear={true}
          className="takaful--service-select takaful--request-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>

      <Row
        justify={"space-between"}
        className="takaful--request-col-space"
        style={{ marginBottom: "2rem" }}
      >
        <Col xxl={5} xl={5} lg={6} md={6} sm={14} xs={14}>
          <PrimaryButton
            onClick={() => setIsModalVisible(true)}
            title=" طلب المنقطعين عن الدراسة "
            className="takaful--add-request-btn"
          />
        </Col>
      </Row>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : droppedOutRequests?.length === 0 &&
        // eslint-disable-next-line eqeqeq
        state.year == "" &&
        !selectedBeneficiary ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا توجد طلبات
        </p>
      ) : droppedOutRequests?.length === 0 &&
        (state.year !== "" || selectedBeneficiary) ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <DroppedOutRequestsList requests={droppedOutRequests} />
          </Row>
          <div className="takaful--pagination-container">
            {droppedOutRequests &&
              Math.ceil(TotalDropouts) * itemPerPage > itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalDropouts) * itemPerPage}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}
      <DropoutRequest
        beneficiary={filterOrphans}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </>
  );
};

export default DroppedOutRequestsOverview;
